import { useState } from 'react';
import PropTypes from 'prop-types';

import Stack from '@mui/material/Stack';
import Popover from '@mui/material/Popover';
import TableRow from '@mui/material/TableRow';
import MenuItem from '@mui/material/MenuItem';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import Iconify from '../../../components/iconify/iconify';

import VisibilityIcon from '@mui/icons-material/Visibility';
import AlertDialogSlide from '../../../shared/popup';
import { Box } from '@mui/material';
import ImageWithFallback from '../../../components/ImageWithFallback';
// ----------------------------------------------------------------------

export default function UserTableRow({
  selected,
  caption,
  images,
  onDelete,
  isSlider,
  // onEdit,

}) {
  const [open, setOpen] = useState(null);
  const [openImages, setOpenImages] = useState(false);

  console.log("images", images)


  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  return (
    <>
      <TableRow hover tabIndex={-1} selected={selected}>
        {/* <TableCell padding="checkbox">
          <Checkbox disableRipple checked={selected} onChange={handleClick} />
        </TableCell> */}

        <TableCell >
          {caption}

        </TableCell>

        <TableCell sx={{ cursor: "pointer" }} onClick={() => setOpenImages(true)}>
          <VisibilityIcon />
        </TableCell>

        <TableCell >
          {isSlider ? "Yes" : "No"}

        </TableCell>


        <TableCell align="right">
          <IconButton onClick={handleOpenMenu}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>

      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: { width: 140 },
        }}
      >
        {/* <MenuItem onClick={onEdit}>
          <Iconify icon="eva:edit-fill" sx={{ mr: 2 }} />
          Edit
        </MenuItem> */}

        <MenuItem onClick={onDelete} sx={{ color: 'error.main' }}>
          <Iconify icon="eva:trash-2-outline" sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
      <AlertDialogSlide
        open={openImages}
        setOpen={setOpenImages}
        fullWidth
        maxWidth="md"

      >
        <Stack px={{ xs: '10px', md: '30px' }} py={{ xs: '10px', md: '18px' }} spacing={1}>

          <Box width="100%" display="flex" flexWrap="wrap" gap={3}>
            {images.map((item, index) => (
              <Box key={index} sx={{ position: "relative", display: "inline-block", margin: "5px", width: "200px", height: "200px" }}>
                <ImageWithFallback
                  path={item?.path}
                  alt="uploaded"
                  height={200}
                  width={200}
                  style={{ borderRadius: "5px", objectFit: "cover" }}
                />

              </Box>
            ))}
          </Box>

        </Stack>
      </AlertDialogSlide>
    </>
  );
}

UserTableRow.propTypes = {
  avatarUrl: PropTypes.any,
  company: PropTypes.any,
  handleClick: PropTypes.func,
  isVerified: PropTypes.any,
  name: PropTypes.any,
  role: PropTypes.any,
  selected: PropTypes.any,
  status: PropTypes.string,
};
